export const SIDEBAR_WIDTH = 220

export default function AppLayout({ toolbar, menu, zone, sidebarOpen, sidebarAnimated }) {
  return (
    <div className="flex flex-col h-screen w-screen overflow-hidden">
      <div id="tbsBannerContainer" className="shrink-0">{toolbar}</div>
      <div className="flex flex-1 overflow-hidden">
        <div
          id="tbsMenuContainer"
          className="shrink-0 overflow-hidden"
          style={{
            width: sidebarOpen ? SIDEBAR_WIDTH : 0,
            // Dégradé "Option D — couleurs de marque" (voir src/index.css, --sidebar-gradient)
            // plutôt qu'un aplat hsl(var(--sidebar)) — --sidebar reste défini (repli/autres
            // usages : flyout de sous-menu), seul le fond du panneau lui-même passe en dégradé.
            background: 'var(--sidebar-gradient)',
            // La largeur de la bordure suit la largeur du panneau plutôt qu'une classe `border-r`
            // statique : une bordure à largeur fixe reste visible (trait résiduel de 1px) même
            // quand le panneau est réduit à width:0, le border-box étant indépendant du contenu.
            borderRightWidth: sidebarOpen ? 1 : 0,
            borderRightStyle: 'solid',
            borderRightColor: 'hsl(var(--sidebar-border))',
            // Pas de transition tant qu'aucune ouverture/fermeture explicite n'a eu lieu (voir
            // App.jsx, sidebarAnimated) — la correction du 1er rendu doit être instantanée.
            transition: sidebarAnimated ? 'width 0.25s ease, border-right-width 0.25s ease' : 'none',
          }}
        >
          <div style={{ width: SIDEBAR_WIDTH, height: '100%', display: 'flex' }}>{menu}</div>
        </div>
        <div id="tbsAppContainer" className="flex-1 flex flex-col overflow-hidden bg-[hsl(var(--secondary))]">
          <div id="tbs-messages-slot" />
          <div className="flex-1 overflow-y-auto p-3">{zone}</div>
        </div>
      </div>
    </div>
  )
}
